import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Logo } from "../Icons";
import { useTranslation } from "react-i18next";
import { Image } from "@learningblocks/shared-components";
import "./style.scss";

/**
 * StaticScreens:
 * - Display the StartScreen and the EndScreen
 */
export function StaticScreens({ scrollTip }) {
  const { t: translate } = useTranslation();

  const startScreen = useRef(null);

  function wrapperClass(animate) {
    return ["splash", animate ? "animate" : ""].join(" ");
  }

  function isStartScreen() {
    return scrollTip >= 0 && scrollTip <= 0.5;
  }

  function isEndScreen() {
    return scrollTip >= 100 && scrollTip < 101;
  }

  useEffect(() => {
    if (isStartScreen()) {
      startScreen.current.focus();
    }
  }, []);

  const labXchangeLogo = (
    <Image alt="LabXchange logo" src={Logo} className="logo" />
  );

  function renderStartScreen() {
    return (
      <div className={wrapperClass(isStartScreen())} id="splashScreen_1">
        {labXchangeLogo}
        <p ref={startScreen} aria-label={translate("interface.introduction")}>
          {translate("interface.callToAction")}
        </p>
        <div className="arrow-down" />
      </div>
    );
  }

  function renderEndScreen() {
    return (
      <div className={wrapperClass(isEndScreen())} id="splashScreen_5">
        {labXchangeLogo}
      </div>
    );
  }

  return (
    <div className="scrolly-static">
      {renderStartScreen()}
      {renderEndScreen()}
    </div>
  );
}

StaticScreens.propTypes = {
  /**
   * Current scrolltip value
   */
  scrollTip: PropTypes.number.isRequired,
};
